import { observer } from "mobx-react-lite";
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { deleteValueCatalogCard } from "src/business/valueCatalog/apiValueCatalog";
import { onError } from "src/common/onError";
import { LoaderBox } from "src/components/LoaderBox";
import { msgQueueStore } from "src/components/MsgQueue";
import { PageLayout } from "src/components/PageLayout";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { ValueCatalogRecForm } from "../ValueCatalogRecForm";
import {
  ValueCatalogRecEditInfo,
  valueCatalogRecEditStore as pageStore,
} from "./ValueCatalogRecEditStore";

export const ValueCatalogRecEdit: React.FC = observer(() => {
  const { id = "" } = useParams();
  React.useEffect(() => {
    pageStore.init(id).catch(onError);
  }, [id]);
  const { data } = pageStore;
  return (
    <PageLayout title={pageStore.crumbs}>
      <LoaderBox
        remoteData={data}
        drawReady={(info) => <Inner data={info} />}
      />
    </PageLayout>
  );
});

const Inner: React.FC<{ data: ValueCatalogRecEditInfo }> = observer(
  ({ data }) => {
    const navigate = useNavigate();
    const onDelete = async () => {
      await deleteValueCatalogCard(data.card.id);
      navigate(makeUrl(PageUrl.valueCatalog, { id: data.catalog.id }), {
        replace: true,
      });
    };
    return (
      <ValueCatalogRecForm
        title={pageStore.title}
        okText="Сохранить"
        form={pageStore.form}
        submit={(dataMap) => pageStore.submit(dataMap)}
        onSuccess={() => {
          msgQueueStore.add({
            type: "info",
            message: "Выполнено обновление данных",
          });
        }}
        onDelete={onDelete}
      />
    );
  },
);
